module.exports = __webpack_public_path__ + "img/684865d.png";